module.exports = __webpack_public_path__ + "img/battery_std.7b30afdb.svg";